import router from 'system/router';
import { useComponentDidMount } from 'utils/hooks/LifecycleHooks';

let _routePid = '';

function setRoutePid(pid: string) {
    _routePid = pid;
}

function getRoutePid() {
    return _routePid;
}

const NO_PID_PART = '-no-pid';

function addNoPidToRouteId(routeId: string) {
    return `${routeId}${NO_PID_PART}`;
}

function removeNoPidFromRouteId(routeId: string) {
    return routeId.replace(NO_PID_PART, '');
}

const pidRegex = /^((?:\/partner)?\/app(?:\/(?:ru|en))?)?(\/(mcs\d+))?(.*)/;

function extractPidFromPath(path: string = window.location.pathname) {
    return path.replace(pidRegex, '$3');
}

const insertPidToPath = (path: string) =>
    path.replace(pidRegex, `$1/:currentpid/$4`);

type Route = Record<string, any>;

const insertPidToRoute = (route: Route, routeId = '', parent = {}) => {
    Object.keys(route).forEach((key) => {
        const value = route[key];

        if (value?.availableWhenUnauthorised || value?.noCurrentPidParam) {
            // eslint-disable-next-line no-useless-return
            return;
        } else if (key === 'url' && typeof value === 'string') {
            if (routeId) {
                parent[addNoPidToRouteId(routeId)] = {
                    ...route,
                    loadPageComponent: undefined,
                    PageComponent() {
                        useComponentDidMount(() => {
                            router.redirectTo(
                                routeId,
                                router.activeRoute.params,
                                router.activeRequest.query,
                                router.activeRoute.details,
                            );
                        });
                        return null;
                    },
                };
            }
            route[key] = insertPidToPath(value);
        } else if (typeof value === 'object') {
            route[key] = insertPidToRoute(value, key, route);
        }
    });

    return route;
};

export const RouterPidHelper = {
    setRoutePid,
    getRoutePid,
    extractPidFromPath,
    insertPidToRoute,
    removeNoPidFromRouteId,
};
